/**
 * @module containers/Station
 * @author Charles Blais <charles.blais@canada.ca>
 * 
 * Display of a single station information
 */

import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Row, Col } from 'react-bootstrap';

import StationSummaryTable from '../components/Table/StationSummaryTable';
import StationMap from '../components/Maps/StationMap';

import { Station } from '../libs/networks'
import ChannelsDetails from '../components/ChannelsDetails';

import { useLanguageState } from '../contexts/LanguageProvider';


const StationContainer = ({networkCode, station, fdsnws}) => {
  const [ lang ] = useLanguageState();
  return (
    <Grid>
      <Row>
        <Col md={12}>
          <h2>{lang.stationTitle} {networkCode}.{station.code}</h2>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <StationSummaryTable
            networkCode={networkCode}
            station={station}
          />
        </Col>
        <Col md={6}>
          <StationMap
            networkCode={networkCode}
            station={station}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <ChannelsDetails
            networkCode={networkCode}
            station={station}
            fdsnws={fdsnws}
          />
        </Col>
      </Row>
    </Grid>
  );
};


StationContainer.propTypes = {
  networkCode: PropTypes.string.isRequired,
  station: PropTypes.instanceOf(Station).isRequired,
  fdsnws: PropTypes.string
};


StationContainer.defaultProps = {
  fdsnws: null,
};


export default StationContainer;
